// import {
//     Message
// } from 'element-ui';
import {Notify} from 'vant'
let messageInstance = null;
/*
{
    message: res.data.message,
    type: 'danger'
}
*/
const resetMessage = (options) => {
    if (messageInstance) {
        messageInstance.clear
    }
    messageInstance = Notify(options)
};
['danger', 'success', 'primary', 'warning'].forEach(type => {
    resetMessage[type] = options => {
        if (typeof options === 'string') {
            options = {
                message: options
            }
        }
        options.type = type
        return resetMessage(options)
    }
})
export default resetMessage
